export default {
      id: "ic-vs-empty-arrow-usage",
      viewBox: "0 0 13 13",
      url: "/" + "images/icons.3.109.2.svg#ic-vs-empty-arrow-usage",
      toString: function () {
        return this.url;
      }
    }